const translate = {
  _HOME_CONTACT: `联系`,
  _BACK: `返回到 `,
  _SEO_TITLE:
    '直接从美国购买汽车 - 我们帮助您购买梦想中的汽车，并节省高达50%的最终成本！',
  _SEO_DESCRIPTION:
    '想从美国购买汽车并运至华沙/弗罗茨瓦夫/波兹南/罗兹以及整个欧盟“一站式服务”？我们可以帮助您！在美国汽车目录中，您可以按美国拍卖的平均价格找到并订购二手车。我们的专家每天为波兰汽车市场精选最佳交易。',
  _HOME_TITLE1: `汽车`,
  _HOME_TITLE2: `直接`,
  _HOME_TITLE3: `来自美国`,
  _HOME_TEXT: `我们帮助您购买梦想中的汽车，并节省高达50%的最终成本！`,
  _HOME_BUTTON: `了解更多`,
  _HOME_BIG_TEXT1:
    '如果您想以低价购买高质量的车辆，可以考虑来自美国的汽车。与本地购买相比，即使算上所有的运输和清关费用，您仍有机会节省高达50%的成本。此外，您还有机会拥有专为美国市场设计的独特车型。',
  _HOME_BIG_TEXT2:
    '我们公司提供各种来自美国的汽车，可根据订单或库存在波兰交付，这些汽车已通过法律检查、技术检查或必要的维修。您可以购买它们并立即使用。我们保证交易的完全透明性，并依法运营，包括增值税。',
  _HOME_BIG_TITLE1: '为什么购买来自美国的汽车？',
  _HOME_BIG_TEXT3:
    '我们的专家每天挑选来自美国的最佳汽车，让您可以在波兰舒适地购买。我们通过使购买过程尽可能愉快、快捷和安全，为您节省时间和金钱。在线拍卖仍然是购买车辆的理想资源，但您也可以以固定价格购买未在拍卖中售出的车辆。这很方便，如果您想“一站式”购买特定车型，而不专注于节省成本。在其他情况下，通过拍卖搜索车辆更为有利，因为：',
  _HOME_BIG_TEXT4: [
    '这是世界上最大的汽车市场；',
    '各种型号和品牌；',
    '透明历史的二手车；',
    '包括独家配置的多种选择。'
  ],
  _HOME_BIG_TEXT5:
    '如果您独立参与拍卖，必须了解许多车辆是在事故后出售的，了解哪些损坏对特定车型是关键的非常重要。最常见的损坏包括碰撞、火灾或水浸。当然，您可以自己前往海外，但这相当昂贵，可能会遇到签证问题，为什么不让我们的专家为您找到“一站式”服务的车型呢？',
  _HOME_BIG_TEXT6:
    '如果您目前没有足够的资金购买汽车，请不用担心。我们提供在波兰分期付款或租赁购买来自美国的汽车的机会。首付款仅为车辆价值的25%，其余款项根据还款期限单独计算。',
  _COMPETITORS: `竞争对手`,
  _ADVANTAGES: `优势`
};

export default translate;
